<template>
    <div v-html="summary"></div>
</template>

<script>
    export default {
        name: 'app-checkout-partials-summary',

        props: {
            loading: {
                type: Boolean,
                default: true
            }
        },

        data: () => ({
            order: {},
            summary: '',
            discounts: true,
        }),

        mounted() {
            this.$emit('loading', true);

            this.get().then(() => {
                return this.check();
            }).then(() => {
                this.$emit('loading', false);
            });
        },

        methods: {
            get() {
                return axios.get('/checkout/summary').then(response => {
                    this.summary = response.data.html;
                    this.order   = response.data.order;
                });
            },

            check() {
                return axios.get('/checkout/discounts').then(response => {
                    this.discounts = response.data.discounts;
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Checkout/Partials/Summary.vue